import { render, staticRenderFns } from "./codeVerify.vue?vue&type=template&id=216789ee&scoped=true"
import script from "./codeVerify.vue?vue&type=script&lang=js"
export * from "./codeVerify.vue?vue&type=script&lang=js"
import style0 from "./codeVerify.vue?vue&type=style&index=0&id=216789ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216789ee",
  null
  
)

export default component.exports